import { render, staticRenderFns } from "./ExpoChapterEntityDetails.vue?vue&type=template&id=5bcd68d4&scoped=true"
import script from "./ExpoChapterEntityDetails.vue?vue&type=script&lang=js"
export * from "./ExpoChapterEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./ExpoChapterEntityDetails.vue?vue&type=style&index=0&id=5bcd68d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd68d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bcd68d4')) {
      api.createRecord('5bcd68d4', component.options)
    } else {
      api.reload('5bcd68d4', component.options)
    }
    module.hot.accept("./ExpoChapterEntityDetails.vue?vue&type=template&id=5bcd68d4&scoped=true", function () {
      api.rerender('5bcd68d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExpoChapterEntityDetails.vue"
export default component.exports